export default __webpack_public_path__ + "static/media/site-541196_1920_copie.7f8e5861.jpg";